'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function CTA({ routes, show }) {
  if (!show) {
    return null;
  }

  return h(
    '.cta-top-offers',
    h(
      'a',
      {
        href: routes.top_offers.main,
        'data-bhw': 'TopOffers',
      },
      [
        h('.label', [
          h('.text', h(Translate, 'modules.widget.Top')),
          h(Translate, 'modules.widget.TopCount'),
        ]),
        h('span.text', h(Translate, 'modules.widget.TopDescription')),
      ]
    )
  );
}

module.exports = CTA;
